// import React from 'react';
// import { Box, Typography, useTheme, Grid } from '@mui/material';
// import { FaCalendarAlt, FaClock } from 'react-icons/fa';
// import { SectionProps, CarePlanFieldPath } from '../../../../types/ndisSection/carePlanInfoTypes';
// import { SectionHeader, CareTextField } from '../Components';

// const getNestedValue = (obj: any, path: string): string => {
//   if (!obj) return 'Not provided';
//   const keys = path.split('.');
//   let current = obj;
//   for (const key of keys) {
//     if (current && typeof current === 'object' && key in current) {
//       current = current[key];
//     } else {
//       return 'Not provided';
//     }
//   }
//   return current || 'Not provided';
// };

// const RegularAppointmentsSection: React.FC<SectionProps> = ({
//   editMode,
//   isMobile,
//   handleEditToggle,
//   handleSubmit,
//   handleCancel,
//   control,
//   errors,
//   getValues,
//   carePlan
// }) => {
//   const theme = useTheme();
//   const spacing = isMobile ? 1 : 2;

//   const fields: { label: string; name: CarePlanFieldPath; icon: JSX.Element }[] = [
//     {
//       label: 'Appointment Type',
//       name: 'RegularAppointments.AppointmentType' as CarePlanFieldPath,
//       icon: <FaClock />
//     },
//     {
//       label: 'Frequency',
//       name: 'RegularAppointments.Frequency' as CarePlanFieldPath,
//       icon: <FaClock />
//     },
//     {
//       label: 'Contact Details',
//       name: 'RegularAppointments.ContactDetails' as CarePlanFieldPath,
//       icon: <FaClock />
//     },
//     { label: 'Physio', name: 'RegularAppointments.Physio' as CarePlanFieldPath, icon: <FaClock /> }
//   ];

//   return (
//     <Box
//       sx={{
//         backgroundColor: theme.palette.background.paper,
//         borderRadius: 2,
//         boxShadow: theme.shadows[1],
//         overflow: 'hidden',
//         width: '100%',
//         maxWidth: '100%',
//         mx: 'auto'
//       }}
//     >
//       <SectionHeader
//         icon={<FaCalendarAlt size={isMobile ? 16 : 20} />}
//         title="Regular Appointments"
//         color={theme.palette.primary.dark}
//         editMode={editMode}
//         handleEditToggle={handleEditToggle}
//         handleSubmit={handleSubmit}
//         handleCancel={handleCancel}
//         getValues={getValues}
//       />

//       <Box sx={{ p: isMobile ? 1 : 2 }}>
//         {editMode ? (
//           <Grid container spacing={spacing}>
//             {fields.map((field) => (
//               <Grid item xs={12} sm={6} key={field.name}>
//                 <CareTextField
//                   label={field.label}
//                   name={field.name}
//                   control={control}
//                   errors={errors}
//                   getValues={getValues}
//                   icon={React.cloneElement(field.icon, { size: isMobile ? 14 : 16 })}
//                   size={isMobile ? 'small' : 'medium'}
//                 />
//               </Grid>
//             ))}
//           </Grid>
//         ) : (
//           <Grid container spacing={spacing}>
//             {fields.map((field) => {
//               const value = getNestedValue(carePlan, field.name);
//               return (
//                 <Grid item xs={12} sm={6} key={field.name}>
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       p: isMobile ? 1 : 1.5,
//                       backgroundColor: theme.palette.background.default,
//                       borderRadius: 1,
//                       height: '100%',
//                       minHeight: isMobile ? 56 : 64,
//                       transition: 'all 0.2s ease',
//                       '&:hover': {
//                         backgroundColor: theme.palette.action.hover
//                       }
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         backgroundColor: theme.palette.primary.light,
//                         color: theme.palette.primary.dark,
//                         borderRadius: '50%',
//                         width: isMobile ? 32 : 36,
//                         height: isMobile ? 32 : 36,
//                         flexShrink: 0
//                       }}
//                     >
//                       {React.cloneElement(field.icon, {
//                         size: isMobile ? 14 : 16
//                       })}
//                     </Box>
//                     <Box sx={{ overflow: 'hidden', flex: 1 }}>
//                       <Typography
//                         variant={isMobile ? 'caption' : 'subtitle2'}
//                         sx={{
//                           fontWeight: 500,
//                           color: theme.palette.text.secondary,
//                           lineHeight: 1.2
//                         }}
//                       >
//                         {field.label}
//                       </Typography>
//                       <Typography
//                         variant={isMobile ? 'body2' : 'body1'}
//                         sx={{
//                           fontWeight: 400,
//                           color: theme.palette.text.primary,
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           display: '-webkit-box',
//                           WebkitLineClamp: 2,
//                           WebkitBoxOrient: 'vertical'
//                         }}
//                       >
//                         {value}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Grid>
//               );
//             })}
//           </Grid>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default RegularAppointmentsSection;


import React from 'react';
import { Box, Typography, useTheme, Grid, IconButton, Button } from '@mui/material';
import { FaCalendarAlt, FaClock, FaTrashAlt, FaPlus } from 'react-icons/fa';
import {
  useFieldArray,
  UseFormSetValue,
  UseFormGetValues,
  Control,
  FieldErrors
} from 'react-hook-form';
import { SectionProps, CarePlanFieldPath } from '../../../../types/ndisSection/carePlanInfoTypes';
import { SectionHeader, CareTextField } from '../Components';

const getNestedValue = (obj: any, path: string): string => {
  if (!obj) return 'Not provided';
  const keys = path.split('.');
  let current = obj;
  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = current[key];
    } else {
      return 'Not provided';
    }
  }
  return current || 'Not provided';
};

const RegularAppointmentsSection: React.FC<SectionProps> = ({
  editMode,
  isMobile,
  handleEditToggle,
  handleSubmit,
  handleCancel,
  control,
  errors,
  getValues
}) => {
  const theme = useTheme();
  const spacing = isMobile ? 1 : 2;

  // Setup useFieldArray
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'RegularAppointments'
  });

  const appointmentFields = [
    { label: 'Appointment Type', key: 'AppointmentType', icon: <FaClock /> },
    { label: 'Frequency', key: 'Frequency', icon: <FaClock /> },
    { label: 'Contact Details', key: 'ContactDetails', icon: <FaClock /> },
    { label: 'Physio', key: 'Physio', icon: <FaClock /> }
  ];

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        boxShadow: theme.shadows[1],
        overflow: 'hidden',
        width: '100%',
        maxWidth: '100%',
        mx: 'auto'
      }}
    >
      <SectionHeader
        icon={<FaCalendarAlt size={isMobile ? 16 : 20} />}
        title="Regular Appointments"
        color={theme.palette.primary.dark}
        editMode={editMode}
        handleEditToggle={handleEditToggle}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        getValues={getValues}
      />

      <Box sx={{ p: isMobile ? 1 : 2 }}>
        {editMode ? (
          <>
            {fields.map((item, index) => (
              <Box key={item.id} sx={{ mb: 2, borderBottom: '1px dashed #ccc', pb: 2 }}>
                <Grid container spacing={spacing} alignItems="center">
                  {appointmentFields.map((field) => (
                    <Grid item xs={12} sm={6} key={field.key}>
                      <CareTextField
                        label={field.label}
                        name={`RegularAppointments.${index}.${field.key}` as any}
                        control={control}
                        errors={errors}
                        getValues={getValues}
                        icon={React.cloneElement(field.icon, { size: isMobile ? 14 : 16 })}
                        size={isMobile ? 'small' : 'medium'}
                      />
                    </Grid>
                  ))}
                  <Grid item xs={12} sx={{ textAlign: 'right' }}>
                    <IconButton color="error" onClick={() => remove(index)} size="small">
                      <FaTrashAlt />
                    </IconButton>
                  </Grid>
                </Grid>
              </Box>
            ))}

            <Box textAlign="left" mt={2}>
              <Button
                variant="outlined"
                startIcon={<FaPlus />}
                onClick={() =>
                  append({
                    AppointmentType: '',
                    Frequency: '',
                    ContactDetails: '',
                    Physio: ''
                  })
                }
              >
                Add Appointment
              </Button>
            </Box>
          </>
        ) : (
          <>
            {(getValues('RegularAppointments') || []).map((item: any, index: number) => (
              <Grid container spacing={spacing} key={index} sx={{ mb: 2 }}>
                {appointmentFields.map((field) => {
                  const value = item?.[field.key] || 'Not provided';
                  return (
                    <Grid item xs={12} sm={6} key={field.key}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          p: isMobile ? 1 : 1.5,
                          backgroundColor: theme.palette.background.default,
                          borderRadius: 1,
                          height: '100%',
                          minHeight: isMobile ? 56 : 64,
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            backgroundColor: theme.palette.action.hover
                          }
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: theme.palette.primary.light,
                            color: theme.palette.primary.dark,
                            borderRadius: '50%',
                            width: isMobile ? 32 : 36,
                            height: isMobile ? 32 : 36,
                            flexShrink: 0
                          }}
                        >
                          {React.cloneElement(field.icon, {
                            size: isMobile ? 14 : 16
                          })}
                        </Box>
                        <Box sx={{ overflow: 'hidden', flex: 1 }}>
                          <Typography
                            variant={isMobile ? 'caption' : 'subtitle2'}
                            sx={{
                              fontWeight: 500,
                              color: theme.palette.text.secondary,
                              lineHeight: 1.2
                            }}
                          >
                            {field.label}
                          </Typography>
                          <Typography
                            variant={isMobile ? 'body2' : 'body1'}
                            sx={{
                              fontWeight: 400,
                              color: theme.palette.text.primary,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical'
                            }}
                          >
                            {value}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            ))}
          </>
        )}
      </Box>
    </Box>
  );
};

export default RegularAppointmentsSection;
